// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomedRadionButton_root__36871","label":"CustomedRadionButton_label__1W3de"};